"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  Contacts: () => Contacts
});
module.exports = __toCommonJS(unavailable_exports);
var import_nativeError = require("../nativeError");
var Contacts = Object.freeze({
  getPermissionStatus: function getPermissionStatus() {
    return "denied";
  },
  requestPermission: function requestPermission() {
    return Promise.resolve("denied");
  },
  pickContact: function pickContact() {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("Contacts.pickContact"));
  },
  search: function search(_name) {
    var _limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    return Promise.resolve([]);
  },
  create: function create(_input) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("Contacts.create"));
  },
  update: function update(_identifier, _changes) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("Contacts.update"));
  },
  delete: function _delete(_identifier) {
    return Promise.resolve();
  }
});
//# sourceMappingURL=unavailable.js.map
